var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMergeLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 4.00001H10.6667M10.6667 6.66671H10.6733M7.99999 6.66671H8.00666M5.33333 6.66671H5.34M7.99999 9.33331H8.00666M10.6667 9.33331H10.6733M5.33333 9.33331H5.34M7.99999 12H8.00666M10.6667 12H10.6733M5.33333 12H5.34M3.99999 1.33331H12C12.7364 1.33331 13.3333 1.93027 13.3333 2.66665V13.3333C13.3333 14.0697 12.7364 14.6666 12 14.6666H3.99999C3.26361 14.6666 2.66666 14.0697 2.66666 13.3333V2.66665C2.66666 1.93027 3.26361 1.33331 3.99999 1.33331Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMergeLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/merge-link.8c6bdd39.svg";
export { ForwardRef as ReactComponent };